module.exports = __webpack_public_path__ + "static/media/john-hawthorne.628648c1.md";